import React, { useState, useEffect } from "react";
import { useApi } from "src/Api/useApi";
import { Modal } from "antd";
import { toast } from "react-toastify";

interface INeurapulseUnlinkModalProps {
	organizationId: number;
	datasetId: number;
	clientId: number;
	visible: boolean;
	onConfirm: () => void;
	onCancel: () => void;
}

const NeurapulseUnlinkModal: React.FC<INeurapulseUnlinkModalProps> = ({
	organizationId,
	datasetId,
	clientId,
	visible,
	onConfirm,
	onCancel,
}) => {
	const [processing, setProcessing] = useState(false);

	const { neurapulseClient } = useApi();

	useEffect(() => {
		// Reset processing state when modal is opened
		if (visible) {
			setProcessing(false);
		}
	}, [visible]);

	const onConfirmClicked = async () => {
		try {
			setProcessing(true);
			if (!neurapulseClient) {
				throw new Error("Neurapulse client is not available");
			}
			await neurapulseClient.unlinkClientAndTestTaker(
				organizationId,
				datasetId,
				clientId
			);
			toast.success("Neurapulse unlinked successfully");
			setProcessing(false);
			onConfirm();
		} catch (error) {
			toast.error("Failed to unlink Neurapulse");
		}
	};

	return (
		<Modal
			visible={visible}
			title="Unlink Neurapulse Confirmation"
			onOk={onConfirmClicked}
			confirmLoading={processing}
			onCancel={onCancel}
			okButtonProps={{
				disabled: processing,
			}}
			okText="Unlink"
			width={"30%"}
		>
			<p>Are you sure you want to unlink Neurapulse?</p>
		</Modal>
	);
};

export default NeurapulseUnlinkModal;
